import { useFields } from './Fields.Context';
import type { FieldsProviderProps } from './Fields.Context';
import { FieldsEditor } from './Fields.Editor';
import { useRecoilValue } from 'recoil';
import { reportStatusState, SECTION_EDITOR_EDITABLE_STATUSES } from '../state';
import { Stack } from 'common/ui/Layout';
import { css } from 'styled-components';
import type { AutoloadTemplateState } from 'hooks/useAutoloadTemplate';

type Props = {
  isDisabled: boolean;
  onInit?: FieldsProviderProps['onInit'];
  onDestroy?: FieldsProviderProps['onDestroy'];
  autoloadTemplateState?: AutoloadTemplateState;
  isLoading?: boolean;
};

export const FieldsSectionEditor = ({
  isDisabled,
  onInit,
  onDestroy,
  autoloadTemplateState,
  isLoading = false,
}: Props): React.ReactElement => {
  const [{ content, editorKey }, { onReportChange }] = useFields();
  const status = useRecoilValue(reportStatusState);

  return (
    <Stack
      data-stack-stretch
      css={css`
        max-height: 100%;
        overflow: hidden;
      `}
      space="small"
      stretchX
      stretchY
    >
      <FieldsEditor
        key={editorKey}
        initialContent={content}
        onChange={onReportChange}
        isDisabled={isDisabled}
        isLoading={isLoading}
        onInit={onInit}
        onDestroy={onDestroy}
        autoloadTemplateState={autoloadTemplateState}
        variant={
          SECTION_EDITOR_EDITABLE_STATUSES.includes(
            status as (typeof SECTION_EDITOR_EDITABLE_STATUSES)[number]
          )
            ? 'report'
            : 'view'
        }
      />
    </Stack>
  );
};
